/* NYUM product-page recovery — keeps the supplement-facts jump independent. */
(function () {
  'use strict';

  function jumpToFacts(event) {
    var link = event.target.closest && event.target.closest('.nyum-v2-facts-jump');
    if (!link) return;
    var target = document.getElementById('nyum-supplement-facts');
    if (!target) return;
    event.preventDefault();
    window.history.replaceState(null, '', '#nyum-supplement-facts');
    var root = document.documentElement;
    var previousScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    var top = target.getBoundingClientRect().top + window.pageYOffset - 112;
    window.scrollTo(0, Math.max(0, top));
    window.setTimeout(function () {
      var settledTop = target.getBoundingClientRect().top + window.pageYOffset - 112;
      window.scrollTo(0, Math.max(0, settledTop));
      root.style.scrollBehavior = previousScrollBehavior;
    }, 500);
  }

  document.addEventListener('click', jumpToFacts, false);
}());
